import styles from '../styles/app.module.css';

interface Props {
  message: string;
}

export function Toast({ message }: Props) {
  return (
    <div role="status" className={styles.toast}>
      {message}
    </div>
  );
}
